import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable()
export class CustomTitleStrategy extends TitleStrategy {
  readonly #prefixTitle = 'SIDECAR | ';

  public constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      this.title.setTitle(`${this.#prefixTitle}${title}`);
    } else {
      const url = routerState.url;
      const pageTitle = this.#getPageTitleFromUrl(url);
      this.title.setTitle(`${this.#prefixTitle}${pageTitle}`);
    }
  }

  #getPageTitleFromUrl(url: string): string {
    const path = url.split('?')[0];
    const segments = path.split('/').filter(Boolean);

    if (segments.length === 0) {
      return 'Home';
    }

    const lastSegment = segments[segments.length - 1];

    return this.#formatTitle(lastSegment);
  }

  #formatTitle(title: string): string {
    return title
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
